import AbstractGroupItem from '../../item/abstractGroupItem';

/**
 * Item depth strategy
 * aka Holex strategy
 * Checks drawer height against full foam thickness + (item height - item depth)
 *
 * @class ItemDepthStrategy
 */
export default class ItemDepthStrategy {
    /**
     * @param {number} maxDrawerDepth
     * @param {number} bagDepthPadding
     */
    constructor(maxDrawerDepth, bagDepthPadding) {
        this.maxDrawerDepth = maxDrawerDepth;
        this.bagDepthPadding = bagDepthPadding;
    }

    /**
     * Checks if the given item fits into the drawer depth.
     *
     * @param {FigureItem|AbstractGroupItem} item Item to check
     * @return {boolean} True if item fits
     */
    checkItemDepth(item) {
        if (item.type !== 'figure' && !(item instanceof AbstractGroupItem)) {
            return true;
        }

        const foam = item.getParentItem();
        const depth = item.get('depth');
        const totalDepth = item.get('totalDepth') || depth;
        const itemStickOutDepth = (totalDepth - depth);
        const foamThickness = foam.get('thickness');

        const currentDepth = Math.floor((itemStickOutDepth + foamThickness) * 10);
        const maxDepth = Math.ceil((this.maxDrawerDepth - this.bagDepthPadding) * 10);

        return currentDepth <= maxDepth;
    }
}
